<template>
  <div role="application" aria-label="Slider color picker" class="vc-slider">
    <div class="vc-slider-hue-warp">
      <hue :value="colors" @change="hueChange"></hue>
    </div>
    <div class="vc-slider-swatches" role="group" v-if="swatches.length">
      <div
        class="vc-slider-swatch"
        v-for="(offset, index) in swatches"
        :key="index"
        :data-index="index"
        :aria-label="'color:' + colors.hex"
        role="button"
        @click="handleSwClick(index, offset)"
      >
        <div
          class="vc-slider-swatch-picker"
          :class="{ 'vc-slider-swatch-picker--active': offset == activeOffset }"
          :style="{
            background:
              'hsl(' + colors.hsl.h + ', 100%, ' + offset * 100 + '%)',
          }"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
import colorMixin from "./SliderColor";
import hue from "vue-color/src/components/common/Hue.vue";

export default {
  name: "CSlider",
  mixins: [colorMixin],
  props: {
    swatches: {
      type: Array,
      default() {
        return [0.9, 0.8, 0.7, 0.6, 0.5, 0.4, 0.3, 0.2, 0.1];
      },
    },
  },
  components: {
    hue,
  },
  computed: {
    activeOffset() {
      const hsl = this.colors.hsl;
      return hsl.s === 1 ? hsl.l : null;
    },
  },
  methods: {
    hueChange(data) {
      this.colorChange({
        ...data,
        s: 1,
        l: 0.5,
      });
    },
    handleSwClick(index, offset) {
      this.colorChange({
        h: this.colors.hsl.h,
        s: 1,
        l: offset,
        source: "hsl",
      });
    },
  },
};
</script>

<style>
.vc-slider {
  position: relative;
  width: 410px;
}
.vc-slider-hue-warp {
  height: 20px;
  position: relative;
}
.vc-slider-hue-warp .vc-hue-picker {
  width: 20px;
  height: 20px;
  border-radius: 20px;
  transform: translate(-10px, -1px);
  background-color: rgb(248, 248, 248);
  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.37);
}
.vc-slider-swatches {
  display: flex;
  margin-top: 20px;
}
.vc-slider-swatch {
  margin-right: 1px;
  flex: 1;
  width: 20%;
}
.vc-slider-swatch:first-child {
  margin-right: 1px;
}
.vc-slider-swatch:first-child .vc-slider-swatch-picker {
  border-radius: 2px 0px 0px 2px;
}
.vc-slider-swatch:last-child {
  margin-right: 0;
}
.vc-slider-swatch:last-child .vc-slider-swatch-picker {
  border-radius: 0px 2px 2px 0px;
}
.vc-slider-swatch-picker {
  cursor: pointer;
  height: 16px;
}
.vc-slider-swatch:nth-child(n)
  .vc-slider-swatch-picker.vc-slider-swatch-picker--active {
  transform: scaleY(1.8);
  border-radius: 3.6px/2px;
}
.vc-slider-swatch-picker--white {
  box-shadow: inset 0 0 0 1px #ddd;
}
.vc-slider-swatch-picker--active.vc-slider-swatch-picker--white {
  box-shadow: inset 0 0 0 0.6px #ddd;
}
</style>
